import(/* webpackMode: "eager" */ "/nomotivation/app/global-error.tsx");
